import { EdgeProps, getSmoothStepPath, EdgeLabelRenderer, BaseEdge, useReactFlow, Node } from 'reactflow';
import styled from 'styled-components';
import { operationType } from '../../services/types';
import { addUpdateNodeToQueue } from '../../services/method';

export function CustomEdge({ id, sourceX, sourceY, targetX, targetY, sourcePosition, targetPosition, data }: EdgeProps) {
   const { getNodes, setNodes, getEdges, setEdges } = useReactFlow();
   const [edgePath, labelX, labelY] = getSmoothStepPath({ sourceX, sourceY, sourcePosition, targetX, targetY, targetPosition });

   // ---
   const handleRemove = () => {
      const nodes: Node<operationType>[] = getNodes();
      const edge = getEdges().find(edge => edge.id === id);
      const target = nodes.find(node => node.id === edge?.target);
      const source = nodes.find(node => node.id === edge?.source);

      setEdges((edges) => edges.filter((edge) => edge.id !== id));
      
      addUpdateNodeToQueue(setNodes, (nodes) => nodes.map((node) => {
         if (node.id === target?.id && node.data.value?.variables) {
            const variables = { ...node.data.value.variables };
            for (let key in variables.input) variables.input[key] = variables.input[key].filter((inx: string) => inx !== source?.data.index);
            return { ...node, data: { ...node.data, value: { ...node.data.value, variables }}};

         } else if (node.id === source?.id && node.data.value?.variables) {
            const variables = { ...node.data.value.variables };
            for (let key in variables.output) variables.output[key] = variables.output[key].filter((inx: string) => inx !== target?.data.index);
            return { ...node, data: { ...node.data, value: { ...node.data.value, variables }}};
         }
         else return node;
      }));
   }

   return (<>
      <BaseEdge 
         id={ id } 
         path={ edgePath }
         style={{ stroke: data?.color || '#06b6d4', strokeWidth: 2 }}
      />
         <EdgeLabelRenderer>
         <Main
            style={{ transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`, pointerEvents: 'all' }}
            className="nodrag nopan"
         >
         <button onClick={ handleRemove } style={{ opacity: data?.isHover ? 1 : 0 }}>x</button>
         </Main>
      </EdgeLabelRenderer>
   </>);
};

// ---
const Main = styled.div`
   position: absolute;

   button {
      width: 22px;
      height: 22px;
      background-color: #F05454;
      color: #fff;
      border: none;
      cursor: pointer;
      border-radius: 50%;
      font-size: 15px;
      font-weight: 400;
      padding-bottom: 2px;
      box-shadow: 0 0 5px #F05454;
      transition: all .2s ease-in-out;

      &:hover {
         opacity: 0.8 !important;
      }
   }
`;